export default "__VITE_ASSET__1c6794bf__"